type JsonHighlightProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    object: any
    className?: string
    dark?: boolean
}
const JsonHighlight = (props: JsonHighlightProps) => {
    const { object, className, dark } = props
    const str = JSON.stringify(object, undefined, 2)

    const highlightJson = (json: string) => {
        json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        return json.replace(
            /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+git -]?\d+)?)/g,
            (content) => {
                let style: string
                if (dark) {
                    style = 'text-yellow-300'
                    if (/^"/.test(content)) {
                        style = /:$/.test(content) ? 'text-blue-300' : 'text-green-300'
                    } else if (/true|false/.test(content)) {
                        style = 'text-orange-300'
                    } else if (/null/.test(content)) {
                        style = 'text-gray-400'
                    }
                } else {
                    style = 'text-brand-primary'
                    if (/^"/.test(content)) {
                        style = /:$/.test(content) ? 'text-brand-secondary' : 'text-green-dark'
                    } else if (/true|false/.test(content)) {
                        style = 'text-orange'
                    } else if (/null/.test(content)) {
                        style = 'text-grey-dark'
                    }
                }
                return '<span class="' + style + '">' + content + '</span>'
            }
        )
    }

    return (
        <pre
            className={`whitespace-pre-wrap break-words max-w-prose mt-3 ${dark ? 'text-gray-200' : ''} ${className ?? ''}`}
            // TODO: Consider finding other solution than dangerouslySetInnerHtml - MINT-605
            dangerouslySetInnerHTML={{
                __html: highlightJson(str),
            }}
        ></pre>
    )
}

export default JsonHighlight
